import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { entityRouteRef, rootRouteRef } from './routes';
import { cdepApiRef, deploymentsApiRef } from './api';
import { CdepClient } from '@appfolio/backstage-plugin-cdep-common';
import { DeploymentsClient } from '@appfolio/backstage-plugin-deployments-common';

export { isDeploymentsAvailable } from './helpers';

export const deploymentsPlugin = createPlugin({
  id: 'appfolio-deployments',
  routes: {
    root: rootRouteRef,
    entity: entityRouteRef,
  },
  apis: [
    createApiFactory({
      api: deploymentsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DeploymentsClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: cdepApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CdepClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const DeploymentsPage = deploymentsPlugin.provide(
  createRoutableExtension({
    name: 'DeploymentsPage',
    component: () =>
      import('./components/DeploymentsPage').then(m => m.DeploymentsPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityDeploymentsContent = deploymentsPlugin.provide(
  createRoutableExtension({
    name: 'EntityDeploymentsContent',
    component: () =>
      import('./components/EntityDeploymentsContent').then(
        m => m.EntityDeploymentsContent,
      ),
    mountPoint: entityRouteRef,
  }),
);

export const EntityDeploymentsCard = deploymentsPlugin.provide(
  createComponentExtension({
    name: 'EntityDeploymentsCard',
    component: {
      lazy: () =>
        import('./components/EntityDeploymentsCard').then(
          m => m.EntityDeploymentsCard,
        ),
    },
  }),
);

export const HomePageDeploymentsCard = deploymentsPlugin.provide(
  createComponentExtension({
    name: 'HomePageDeploymentsCard',
    component: {
      lazy: () =>
        import('./components/HomePageDeploymentsCard').then(
          m => m.HomePageDeploymentsCard,
        ),
    },
  }),
);
